var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-hero-image"},[_c('div',{staticClass:"audio-hero-image__container"},[_c('pict',{attrs:{"block-name":"audio-hero-image__phone","default":_vm.imageSources[0],"sources":_vm.imageSources}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }